<template>
  <div class="reports-list-view reports-typography">
    <header class="reports-toolbar">
      <ReportModeSwitcher v-model="activeMode" />
    </header>

    <section
      :id="activePanelId"
      class="reports-panel"
      :aria-label="activePanelLabel"
      role="tabpanel"
    >
      <component
        :is="activePanel.component"
        v-bind="activePanel.props"
        v-on="activePanel.listeners"
      />
    </section>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import ReportModeSwitcher from '@/components/reports/ReportModeSwitcher.vue';
import '@/assets/styles/payment-lists.css';
import AnalyticsListView from '@/views/analytics/AnalyticsListView.vue';
import WorkPermissionsListView from '@/views/reports/WorkPermissionsListView.vue';
import DocumentsStatusListView from '@/views/reports/DocumentsStatusListView.vue';

const emit = defineEmits(['open-editor']);
const activeMode = ref('analytics');

const handleOpenEditor = (payload = {}) => {
  const reportType = payload?.reportType || activeMode.value || 'analytics';
  emit('open-editor', {
    ...payload,
    reportType,
  });
};

const reportPanels = {
  analytics: {
    label: 'Analytics',
    component: AnalyticsListView,
    props: { showHeader: false },
    listeners: { 'open-editor': handleOpenEditor },
  },
  'work-permissions': {
    label: 'Work permissions',
    component: WorkPermissionsListView,
    props: { showHeader: false },
    listeners: {},
  },
  'documents-status': {
    label: 'Documents status',
    component: DocumentsStatusListView,
    props: { showHeader: false },
    listeners: {},
  },
};

const activePanel = computed(() => reportPanels[activeMode.value] || reportPanels.analytics);
const activePanelId = computed(() => `report-panel-${activeMode.value}`);
const activePanelLabel = computed(() => activePanel.value.label);
</script>

<style scoped>
/* Uses the list styles of the Payments and journal pages. */
.reports-list-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100%;
  padding: 24px;
  box-sizing: border-box;
  background: var(--noc-background);
  color: var(--text-color);
  font: var(--ap-type-body);
}

.reports-toolbar {
  display: flex;
  align-items: center;
  min-width: 0;
}

.reports-panel {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
}

.reports-panel > :deep(*) {
  flex: 1 1 auto;
  min-width: 0;
}

@media (max-width: 768px) {
  .reports-list-view {
    padding: 16px;
  }
}
</style>
